<template>
  <div class="row">
    <snappy-table
      :endpoint="'vessels/' + vesselId + '/activities/stream/recent-campaigns?campaign_id=' + campaignId"
      :columns="['type', 'created_at']"
      :template-methods="columnTemplates(timezone)"
      :templated-slot-names="['type']"
      :headings="['Activity', 'Date']"
      :filterable-columns="['type', 'created_at']"
      :filter-values="filterValues"
      :default-params="{'activity_type_ids[]': [5, 16, 18, 19, 21, 30]}"
      :filter-params-mapper="{type: 'activity_type_ids[]'}"
      :handle-row-click="onRowClick"
      record-type="Activities"
    >
      <template #type="{row}">
        <div v-if="row.activity_type === 'clicks'">
          <span class="label label-clicks">
            <i class="fas fa-bullseye" aria-hidden="true"></i>
            &nbsp;Clicked {{ row.step }}
          </span>
        </div>
        <div v-else-if="row.activity_type === 'opens'">
          <span class="label label-opens">
            <i class="fas fa-envelope" aria-hidden="true"></i>
            &nbsp;Opened {{ row.step }}
          </span>
        </div>
        <div v-else-if="row.activity_type === 'views'">
          <span class="label label-views">
            <i class="fas fa-eye" aria-hidden="true"></i>
            &nbsp;Viewed {{ row.step }}
          </span>
        </div>
        <div v-else-if="row.activity_type === 'form-submissions'">
          <span class="label label-form">
            <i class="fas fa-file-alt" aria-hidden="true"></i>
            &nbsp;Completed {{ row.step }} Form
          </span>
        </div>
        <div v-else-if="row.activity_type === 'emails'">
          <span class="label label-email"> <i class="fas fa-envelope" aria-hidden="true"></i> &nbsp;Sent Email </span
          ><br />
          <span>
            <strong>{{ row.step }}</strong> to
            <span v-if="typeof row.contact.name !== 'undefined' && row.contact.name != ''">
              {{ row.contact.name }}
            </span>
            <span v-else>{{ row.contact.email }}</span>
          </span>
        </div>
        <div v-else-if="row.activity_type === 'texts'">
          <span class="label label-email"> <i class="fas fa-sms" aria-hidden="true"></i> &nbsp;Sent Text </span><br />
          <span>
            <strong>{{ row.step }}</strong> to {{ row.contact.name }}
          </span>
        </div>
        <div v-else-if="row.activity_type === 'social-posts' && typeof row.meta !== 'undefined'">
          <div v-if="row.meta.network === 'facebook-page-posts'">
            <span class="label label-facebook">
              <i class="fab fa-facebook" aria-hidden="true"></i> &nbsp;Posted to Facebook Page </span
            ><br />
          </div>
          <div v-else-if="row.meta.network === 'twitter-personal-posts'">
            <span class="label label-twitter">
              <i class="fab fa-twitter" aria-hidden="true"></i> &nbsp;Posted to Twitter Profile </span
            ><br />
          </div>
          <div v-else-if="row.meta.network === 'linkedin-personal-posts'">
            <span class="label label-linkedin">
              <i class="fab fa-linkedin" aria-hidden="true"></i> &nbsp;Posted to LinkedIn Profile </span
            ><br />
          </div>
        </div>
        <div v-else>
          {{ row.activity_type }}
        </div>
      </template>
    </snappy-table>
  </div>
</template>

<script>
import SnappyTable from '../../components/SnappyTable';
import columnTemplates from '../../mixins/tables/columnTemplates';

export default {
  name: 'manage-campaign-recent-campaign-activities-table',
  mixins: [columnTemplates],
  components: {SnappyTable},
  props: {
    vesselId: {
      type: Number,
      required: true,
    },
    campaignId: {
      type: Number,
      required: true,
    },
    timezone: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      filterValues: {
        type: [
          {
            id: 5,
            text: 'Sent Email',
          },
          {
            id: 16,
            text: 'Posted to Facebook Page',
          },
          {
            id: 18,
            text: 'Posted to Twitter',
          },
          {
            id: 19,
            text: 'Posted to LinkedIn',
          },
          {
            id: 21,
            text: 'Sent Text',
          },
          {
            id: 30,
            text: 'Forwarded Email',
          },
        ],
      },
    };
  },
  methods: {
    onRowClick(event) {
      window.location.href = '/inventory/contacts/edit?sk_token=' + this.contactToken(event.row.contact_id);
    },
    contactToken(id) {
      return btoa('contact_id=' + id);
    },
  },
};
</script>
